import { render } from "./AnimatedButton.vue?vue&type=template&id=48675158&scoped=true"
import script from "./AnimatedButton.vue?vue&type=script&lang=js"
export * from "./AnimatedButton.vue?vue&type=script&lang=js"

import "./AnimatedButton.vue?vue&type=style&index=0&id=48675158&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48675158"]])

export default __exports__